

import Q2DeskAreaCardsPattern, { SelectState } from "./q2_desk_area_cards_pattern";
import EventManager from "../../../../manager/event_manager";
import Q2MyHandCardsPattern from "./q2_my_handcards_pattern";

const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2MyHandCardsPatterns extends cc.Component{

    @property(cc.Node)
    root: cc.Node = null

    @property(Q2MyHandCardsPattern)
    patternPrefab: Q2MyHandCardsPattern = null
    
    
    protected m_patternList: Q2MyHandCardsPattern[] = []

    protected getPattern(index: number){
        let pattern = this.m_patternList[index]
        if(!pattern){
            pattern = cc.instantiate(this.patternPrefab.node).getComponent(Q2MyHandCardsPattern)
            pattern.node.active = true
            pattern.node.parent = this.root
            pattern.node.scale = 1
            pattern.node.position = cc.Vec2.ZERO
            this.m_patternList[index] = pattern
        }        
        return pattern
    }

    showPokers(show: boolean, raiseCodeList: number[], storageCodeList: number[], attachCodeList: number[], discardCode: number){
        if(show){
            let fromIndex = 0
            this.showPatterns(fromIndex, raiseCodeList, 1)
            fromIndex += 1
            this.showPatterns(fromIndex, storageCodeList, 2)
            fromIndex += 1
            this.showPatterns(fromIndex, attachCodeList, 3)
            fromIndex += 1
            this.showPatterns(fromIndex, [discardCode], 4)
        }else{
            for (let index = 0; index < this.m_patternList.length; index++) {
                const element = this.m_patternList[index];
                element.showPokers(false)
            }
        }        
    }


    protected showPatterns(fromIndex: number, codeList: number[], state: number){
        let pattern = this.getPattern(fromIndex)
        pattern.node.active = codeList.length > 0
        if(codeList.length > 0){
            pattern.showPokers(true, codeList)
            pattern.showRaiseTag(state == 1)
            pattern.showStorageTag(state == 2)
            pattern.showAttachTag(state == 3)
            pattern.showDiscardTag(state == 4)
        }

    }
}
